// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v6jn","type":"styles_type__YufSN","choices":"styles_choices__1llL9"};